export const Toolbar = ({ children }) => {
  return <div className="slate--toolbar">{children}</div>;
};
